import { useMemo } from "react";
import { useSelector } from "react-redux";

import { authProtectedRoutes } from "./allRoutes";

const useRoutes = () => {
  const { roles, user } = useSelector((state) => state.Login);
  const token = localStorage.getItem("giftCityToken");

  const isLoading = useMemo(
    () => !!token && !(user && roles.length),
    [user, token, roles]
  );

  const authRoutes = authProtectedRoutes.filter(
    ({ allowRoles }) => !!roles.find((role) => allowRoles.includes(role))
  );

  return { isLoading, authRoutes };
};

export default useRoutes;
